import { styled } from '@mui/material/styles';
import DataTable from 'components/DataTable';

export const PodcastContentTable = styled(DataTable)`
  max-height: 800px;
` as typeof DataTable;
